import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography } from '@creditas/typography'

const GenericErrorFeedback: FC = () => {
  const { t } = useTranslation(['surprise'])

  return (
    <>
      <Typography variant="form">
        {t('feedbacks.generic-error.title')}
      </Typography>
      <Typography variant="support">
        {t('feedbacks.generic-error.message')}
      </Typography>
    </>
  )
}

export { GenericErrorFeedback }
